import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/esm/Button";
import UserInput from "./UserInput";
import GameStart from "../../utils/GameStart";
import BackToGameList from "../../utils/BackToGameList";

function HighLow(props) {
  const [variant, setVariant] = useState();
  const [alertText, setAlertText] = useState();
  const [userNumber, setUserNumber] = useState();
  const [alertUser, setAlertUser] = useState(false);
  const [oldNumbers, setOldNumbers] = useState([]);
  const [endgame, setEndGame] = useState(false);
  const [resetButtonLogic, setResetButtonLogic] = useState(false);
  const [triggerTimer, setTriggerTimer] = useState();
  const [time, setTime] = useState(0);
  const [timesPlayed, setTimesPlayed] = useState(0);
  const [openGameStartModal, setOpenGameStartModal] = useState();
  const [randomNumber, setRandomNumber] = useState(
    Math.floor(Math.random() * 100) + 1
  );

  const numberSubmit = (number) => {
    if (number > randomNumber) {
      setAlertUser(true);
      setVariant("secondary");
      setAlertText(number + " was too high. Please try again!");
    }
    if (number < randomNumber) {
      setAlertUser(true);
      setVariant("secondary");
      setAlertText(number + " was too low. Please try again!");
    }
    if (number === randomNumber) {
      setAlertUser(true);
      setUserNumber(number);
      setVariant("success");
      setAlertText(number + " was correct. Congratulations!");
    }
  };

  const proccessReset = () => {
    setAlertUser(false);
    setOldNumbers([]);
    setEndGame(false);
    setAlertText("");
    setRandomNumber(Math.floor(Math.random() * 100) + 1);
    setTime(0);
    setResetButtonLogic(false);
  };

  const proccessEndgame = () => {
    setEndGame(true);
  };

  const resetButton = (
    <Button onClick={proccessReset} style={{ marginLeft: "235px" }}>
      Reset Game
    </Button>
  );

  useEffect(() => {
    if (oldNumbers.length === 10) {
      setAlertUser(true);
      proccessEndgame();
      setResetButtonLogic(true);
      setVariant("danger");
      setAlertText(
        "Game Over, you've guessed 10 times. Try again by resetting your game with the Reset Game Button! Thanks for playing!"
      );
    }
    if (userNumber === randomNumber) {
      setAlertUser(true);
      proccessEndgame();
      setResetButtonLogic(true);
      setTimesPlayed((prevPlayed) => prevPlayed + 1);
      clearInterval(triggerTimer);
      setOpenGameStartModal(true);
      setVariant("success");
      setAlertText(
        "Congratulations! You successfully guessed the number. Thank you for playing. To play again press the Reset Game Button."
      );
    }
  }, [oldNumbers, userNumber, randomNumber, triggerTimer]);
  return (
    <>
      <BackToGameList />
      <GameStart
        check={props.errorCheck}
        timer={props.timerCheck}
        onStartTime={setTriggerTimer}
        setTime={setTime}
        openGameStartModal={openGameStartModal}
        timesPlayed={timesPlayed}
        setResetGame={proccessReset}
        onGameStartModal={setOpenGameStartModal}
        gameTitle={"High Low"}
        gameDescription={`We have selected a random number between 1 and 100. See if you can guess it in 10 turns or fewer. We'll tell you if your guess was too high or too low. To play, touch the "Start Game" button. Thank you for playing, and enjoy!`}
      />
      {props.timerCheck ? (
        <Card style={{ marginBottom: "10px" }}>
          <Card.Body>Current Time: {time}</Card.Body>
        </Card>
      ) : (
        ""
      )}
      <Card
        style={{
          margin: "20px",
          marginTop: "100px",
          background: "rgb(179 220 255)",
          border: "1px solid rgb(0 0 0 / 20%)",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          padding: "20px",
          fontSize: "32px",
        }}
      >
        <Card.Header>
          High Low - A Guessing Game {resetButtonLogic ? resetButton : ""}
        </Card.Header>
        <Card.Body>
          <p>
            We have selected a random number between 1 and 100. See if you can
            guess it in 10 turns or fewer. We'll tell you if your guess was too
            high or too low.
          </p>
          <div style={{ fontSize: "22px" }}>
            <ul>
              <li>
                <b style={{ color: "rgb(255 177 0)" }}>Too High</b>{" "}
              </li>
              <li>
                {" "}
                <b style={{ color: "blue" }}>Too Low</b>{" "}
              </li>
              <li>
                {" "}
                <b style={{ color: "green" }}>Correct Number</b>
              </li>{" "}
            </ul>
          </div>
          <UserInput
            onNumberSubmission={numberSubmit}
            messageBackVariant={variant}
            messageBackAlertText={alertText}
            onSetOldNumbers={setOldNumbers}
            oldNumbers={oldNumbers}
            alertUser={alertUser}
            endgame={endgame}
          />
          Your previous guesses:
          {oldNumbers.map((n) => {
            if (n > randomNumber) {
              return (
                <b key={n + Math.random()} style={{ color: "rgb(255 177 0)" }}>
                  {n},{" "}
                </b>
              );
            }
            if (n < randomNumber) {
              return (
                <b key={n + Math.random()} style={{ color: "blue" }}>
                  {n},{" "}
                </b>
              );
            } else {
              return (
                <b key={n + Math.random()} style={{ color: "green" }}>
                  {n}
                </b>
              );
            }
          })}
        </Card.Body>
      </Card>
    </>
  );
}

export default HighLow;
